/**
 * Author: Wilson Pilco Nuñez
 * Email: wilsonaux1@gmail.com
 * Created at: 2025-11-13 20:36
 */

import { saveAs } from "file-saver";
import XLSX from "xlsx";

function saveTableInExcel(tbl, fileName) {
  var wb = XLSX.utils.table_to_book(tbl);
  var wopts = {bookType: "xlsx", bookSST: false, type: "binary"};
  var wbout = XLSX.write(wb, wopts);
  function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  }
  saveAs(
    new Blob([s2ab(wbout)], {type: "application/octet-stream"}),
    fileName
  );
}

/**
 * Converts an array of register objects to XLSX and downloads the file
 * @param {Array} registers - Array of objects with structure { id, name, idcard, tel }
 * @param {string} filename - Optional filename (default: 'registers.xlsx')
 */
function exportRegistersToXLSX(headers, registers, filename = 'registers.xlsx') {
  // Validate input
  if (!Array.isArray(registers) || registers.length === 0) {
    // console.error('Invalid input: registers must be a non-empty array');
    return;
  }

  // Transform data to include headers
  const data = [
    headers, // Headers
    ...registers
  ];


  // Create worksheet from data
  const worksheet = XLSX.utils.aoa_to_sheet(data);

  // Set column widths for better readability
  worksheet['!cols'] = [
    { wch: 10 },  // ID column
    { wch: 25 },  // Name column
    { wch: 20 },  // ID Card column
    { wch: 15 }   // Telephone column
  ];

  // Create workbook and add worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Registers');

  // Generate XLSX file and trigger download
  XLSX.writeFile(workbook, filename);
}

export {
  saveTableInExcel,
  exportRegistersToXLSX
}
